import React, { useState } from "react";
import { uploadFile } from "@/lib/api";
import { Paperclip, X, Loader2, Check } from "lucide-react";

export function FileUpload({ value = [], onChange, testId = "file-upload" }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const handle = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    setError("");
    try {
      const uploaded = [];
      for (const f of files) {
        const res = await uploadFile(f);
        uploaded.push({ id: res.id, original_filename: res.original_filename });
      }
      onChange([...(value || []), ...uploaded]);
    } catch (err) {
      setError("Upload failed. Please try again.");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  const remove = (id) => onChange(value.filter((f) => f.id !== id));

  return (
    <div data-testid={testId}>
      <label className="flex items-center gap-3 border border-steel bg-nearblack px-5 py-4 cursor-pointer hover:border-offwhite/40 transition-colors group">
        {busy ? <Loader2 className="w-4 h-4 animate-spin text-strike" /> : <Paperclip className="w-4 h-4 text-mutedgray group-hover:text-strike transition-colors" />}
        <span className="font-mono-tech text-xs uppercase tracking-[0.15em] text-mutedgray">
          {busy ? "Uploading…" : "Attach photo / document"}
        </span>
        <input type="file" multiple accept="image/*,.pdf,.doc,.docx" className="hidden" onChange={handle} data-testid={`${testId}-input`} />
      </label>
      {error && <p className="text-strike font-mono-tech text-xs mt-2">{error}</p>}
      {value?.length > 0 && (
        <ul className="mt-3 space-y-2">
          {value.map((f) => (
            <li key={f.id} className="flex items-center justify-between border border-steel/60 px-4 py-2 text-sm" data-testid={`file-${f.id}`}>
              <span className="flex items-center gap-2 text-offwhite/80 truncate">
                <Check className="w-3.5 h-3.5 text-strike" /> {f.original_filename}
              </span>
              <button type="button" onClick={() => remove(f.id)} className="text-mutedgray hover:text-strike" aria-label="Remove file">
                <X className="w-4 h-4" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
